const DEFAULT_INTERVAL = 1000
const MAX_INTERVAL = 5000

// Resilient polling loop: keeps re-trying forever regardless of the outcome of
// each attempt. When the daemon is unreachable (restart, USB wedge), a failed
// poll must not kill the loop — it backs off and re-tries so the app recovers
// automatically once the daemon is back. Each attempt awaits the callback, so
// the caller must return a promise that rejects on failure (dispatch().unwrap()).
export const dataFetcher = (() => {
    let fetching = false
    let timeout = null
    let baseInterval = DEFAULT_INTERVAL
    let currentInterval = DEFAULT_INTERVAL
    let getData

    async function poll() {
        if (!fetching) return
        try {
            await getData()
            currentInterval = baseInterval
        } catch (e) {
            currentInterval = Math.min(currentInterval * 2, MAX_INTERVAL)
        }
        if (fetching) timeout = setTimeout(poll, currentInterval)
    }

    return {
        init(callback, _interval = DEFAULT_INTERVAL) {
            getData = callback
            if (_interval > 0) {
                baseInterval = _interval
                currentInterval = _interval
            }
        },
        start() {
            fetching = true
            currentInterval = baseInterval
            if (timeout == null) timeout = setTimeout(poll, 0)
        },
        stop() {
            fetching = false
            if (timeout != null) {
                clearTimeout(timeout)
                timeout = null
            }
        },
        next() {
            if (!fetching) return
            if (timeout != null) clearTimeout(timeout)
            timeout = setTimeout(poll, currentInterval)
        },
    }
})()
